import {fileToBase64} from "./base64/fileToBase64";

export const handleImageBase64Conversion = async (params) => {
    let imageBase64;
    if (params.data.imageBase64 && params.data.imageBase64.rawFile instanceof File) {
        imageBase64 = await fileToBase64(params.data.imageBase64.rawFile);
    }
    params.data.imageBase64 = imageBase64;
    return params;
};